var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "cargo-advance-search",
            staticStyle: {
              width: "100%",
              "margin-top": "5px",
              "min-width": "1280px"
            }
          },
          [
            _c(
              "el-form",
              { attrs: { "label-position": "middle", "label-width": "80px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-form-item-wrapper",
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SystemMaintenance.RuleName") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            no: "0",
                            placeholder: _vm.$t("SeaExport.PleaseInputAKeyword")
                          },
                          model: {
                            value: _vm.filter.ruleName,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "ruleName", $$v)
                            },
                            expression: "filter.ruleName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessType") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "290px" },
                          attrs: {
                            no: "1",
                            "tag-value": "code",
                            filterable: "",
                            clearable: "",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_SystemConstants$SOP_CONFIG_LOBS
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.filter.lob = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "padding-left": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "3", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.filter.pageNum = 1
                                _vm.queryHandler()
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                            )
                          ]
                        ),
                        _vm.isPlatform
                          ? _c(
                              "el-button",
                              {
                                attrs: { no: "4", type: "primary" },
                                on: { click: _vm.addHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Add")) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isPlatform
                          ? _c(
                              "el-button",
                              {
                                attrs: { no: "5", type: "primary" },
                                on: { click: _vm.editHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Edit")) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isPlatform
                          ? _c(
                              "el-button",
                              {
                                attrs: { no: "6", type: "danger" },
                                on: { click: _vm.deleteHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_OrderDelete")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section grid-wrapper",
            staticStyle: { "flex-grow": "1" }
          },
          [
            _c("cargo-ag-grid", {
              attrs: {
                no: "grid",
                "config-module": "1014253",
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "app-main-inner-row row-pagination" },
          [
            _c("cargo-pagination", {
              attrs: {
                no: "pagination",
                "config-module": "1014253",
                total: _vm.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.queryHandler
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "settingDialog",
          attrs: {
            visible: _vm.settingDialog.visible,
            title: _vm.settingDialog.title,
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.settingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-width": "130px", "label-position": "right" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.RuleName") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "390px" },
                        attrs: { no: "ruleName", maxlength: "20" },
                        on: {
                          blur: function() {
                            return (_vm.settingDialog.form.ruleName = _vm.settingDialog.form.ruleName.trim())
                          }
                        },
                        model: {
                          value: _vm.settingDialog.form.ruleName,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "ruleName", $$v)
                          },
                          expression: "settingDialog.form.ruleName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BusinessType"),
                        "label-width": "130px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "390px" },
                        attrs: {
                          no: "lob",
                          "tag-value": "code",
                          filterable: "",
                          clearable: "",
                          multiple: "",
                          "default-multiple-value": _vm.toArray(
                            _vm.settingDialog.form.lob
                          ),
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$SOP_CONFIG_LOBS
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.settingDialog.form.lob = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.ApplicationModule")
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "isApplyUiCustom" },
                          model: {
                            value: _vm.settingDialog.form.isApplyUiCustom,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.settingDialog.form,
                                "isApplyUiCustom",
                                $$v
                              )
                            },
                            expression: "settingDialog.form.isApplyUiCustom"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.UICustomisation"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "isApplySopBoard" },
                          model: {
                            value: _vm.settingDialog.form.isApplySopBoard,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.settingDialog.form,
                                "isApplySopBoard",
                                $$v
                              )
                            },
                            expression: "settingDialog.form.isApplySopBoard"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SOPPanel")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "isApplySopStateTrigger" },
                          model: {
                            value:
                              _vm.settingDialog.form.isApplySopStateTrigger,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.settingDialog.form,
                                "isApplySopStateTrigger",
                                $$v
                              )
                            },
                            expression:
                              "settingDialog.form.isApplySopStateTrigger"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SOPStatusTrigger"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_RuleCode") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "390px" },
                        attrs: { type: "textarea", rows: 3, no: "ruleCode" },
                        on: {
                          blur: function() {
                            return (_vm.settingDialog.form.ruleCode = _vm.settingDialog.form.ruleCode.trim())
                          }
                        },
                        model: {
                          value: _vm.settingDialog.form.ruleCode,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "ruleCode", $$v)
                          },
                          expression: "settingDialog.form.ruleCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CodeParameterValues")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "390px" },
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          no: "codeParamDescription"
                        },
                        on: {
                          blur: function() {
                            return (_vm.settingDialog.form.codeParamDescription = _vm.settingDialog.form.codeParamDescription.trim())
                          }
                        },
                        model: {
                          value: _vm.settingDialog.form.codeParamDescription,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settingDialog.form,
                              "codeParamDescription",
                              $$v
                            )
                          },
                          expression: "settingDialog.form.codeParamDescription"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CreateSource") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "isPlatform" },
                          on: { change: _vm.isPlatformChange },
                          model: {
                            value: _vm.settingDialog.form.isPlatform,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.settingDialog.form,
                                "isPlatform",
                                $$v
                              )
                            },
                            expression: "settingDialog.form.isPlatform"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Platform")))
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Tenant")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.settingDialog.form.isPlatform
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.TENANT_BUSINESS_NAME")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "390px" },
                            attrs: {
                              no: "tenant",
                              multiple: "",
                              "select-type": _vm.selectTypeNames.TENANT,
                              cache: false,
                              filterable: "",
                              clearable: "",
                              "custom-label": function(item) {
                                return "[" + item.id + "]" + item.name
                              },
                              "default-multiple-value":
                                _vm.settingDialog.form.tenantIds || []
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.settingDialog.form.tenantIds =
                                  p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.descr") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "390px" },
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          no: "remark",
                          maxlength: "200"
                        },
                        on: {
                          blur: function() {
                            return (_vm.settingDialog.form.remark = _vm.settingDialog.form.remark.trim())
                          }
                        },
                        model: {
                          value: _vm.settingDialog.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.settingDialog.form, "remark", $$v)
                          },
                          expression: "settingDialog.form.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "13", type: "primary" },
                  on: { click: _vm.saveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "14" },
                  on: {
                    click: function($event) {
                      _vm.settingDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }